module.exports = function() {
  return new Worker(__webpack_public_path__ + "07d41f1d92793e06f319.worker.js");
};